"use client";

import React, { useEffect, useState } from "react";
// import Vendor_form from "./Vendor_form";
import { useSelector } from "react-redux";
import Image from "next/image";
import Vendor_form from "@/components/Vendor_form/Vendor_form";
import OtherPageBanner from "@/components/OtherPageBanner/OtherPageBanner";

function Vendor({ vendorData }) {
  const [isMobilescreen, setMobilescreen] = useState(false);
  // const [vendorData, setVendor] = useState(null);

  const countryList = useSelector((state) => state.inquiry.countryList);

  useEffect(() => {
    // let vendorDData = {};
    // if (vendorData == null) {
    //   vendorDData = pageList.find((page) => page.slug == "vendor");
    //   setVendor(vendorDData);
    // }

    if (window.innerWidth <= 767) setMobilescreen(true);
  }, []);

  //    if (!vendorData || !vendorData?.page_name) return null;

  return (
    <>
      <div className="vendor_wrapper">
        <div className="reecosys-main-wrapper" id="reecosys-main-wrapper">
          <div id="reecosys-contact-wrapper" className="relative">
            {/* <section
              className="reecosys-section relative"
              id="reecosys-contact-us-section-1"
            >
              <div className="common-listing-banner relative">
                <img
                  src={`${vendorData?.banner_web_full}&h=800&w=1903&q=100`}
                  alt=""
                  className="hide-tab-mobile"
                />
                {isMobilescreen && (
                  <img
                    src={`${vendorData?.banner_mobile_full}&h=700&w=500&q=100`}
                    className="visible-tab-mobile"
                    alt="Mobile Banner"
                    style={{ height: "unset" }}
                  />
                )}
                <div className="common-list-overlay"></div>
              </div>
              <div className="black_overlay "></div>
            </section> */}
            {/* <div className="care-wrapper relative">
             
              <div className="inner-flex main-container-fluid inner-flex-big5 section-paddinglarge">
                <div className="flex-row section-flex2">
                  <div className="section-title64 section-text">
                    <h1 className="bold-fonts">Vendor</h1>
                  </div>
                  <div className="relative section-image">
                    <img
                      src={`${vendorData.banner_web_full}&w=1338&h=720&q=100`}
                      alt=""
                      className="hide-tab-mobile"
                    />
                    <img
                      src={`${vendorData.banner_web_full}&w=1920&h=1500&q=100`}
                      alt=""
                      className="visible-tab-mobile"
                      style={{ height: "unset" }}
                    />
                  </div>
                </div>

                <div className="section-sub-text section-content22">
                  <p className="regular-fonts">
                    Join NB Group vendor network and be part of our trusted team
                    in the real estate market. Grow your business with ours and
                    build a strong partnership based on trust and shared
                    success. We're here to support you every step of the way!
                  </p>
                </div>
              </div>
            </div> */}
            <OtherPageBanner
              title="Vendor"
              subtitle="Building With Excellence"
              description="Join NB Group vendor network and be part of our trusted team in the real estate market. Grow your business with ours and build a strong partnership based on trust and shared success. We're here to support you every step of the way!"
              bannerWeb={vendorData?.banner_web_full}
            />
            <section
              className="reecosys-section commonpage_form_section section-padding relative light-bg-section"
              id="reecosys-contact-section-1"
            >
              <div className="form-container">

                <div className="inner-flex inner-flex-medium">
                  <div className="page-list-2-col-grid">
                    <div className="inner-flex">
                      <div className="section-information">
                        <div className="section-title-big">
                          <h2
                            className="capitalize"
                            style={{ width: "max-content" }}
                          >
                            Join Now
                          </h2>
                        </div>
                      </div>

                      {/* <div className="section-content">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: vendorData.primary_text_display,
                        }}
                      ></p>
                    </div> */}
                    </div>

                    <div className="content-size-div banner-content-size-div contact_detail comonpage_discription">
                      <Vendor_form countryList={countryList} />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default Vendor;
